import React from "react";
import styled from "styled-components";
import { FlexRowContainer } from "@trailhead/core-ui";
import { Button as AsurionButton, breakpoints, Icon } from "@trailhead/asurion-ui";
import { trackEvent } from "@trailhead/analytics";
import { useSanitizedTranslation } from "@trailhead/i18n";

const ButtonContainer = styled(FlexRowContainer)`
  justify-content: center;
`;

const MainButtonContainer = styled(ButtonContainer)`
  padding-top: 20px;
`;

const IconContainer = styled.div`
  padding-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AsurionButtonWrapper = styled(AsurionButton)`
  height: auto;
  max-height: 3rem;
  margin: 1% 1%;

  ${breakpoints.sm} {
    max-width: 350px;
  }
`;

const TagButton = styled(AsurionButtonWrapper)`
  border-color: #a5aaaf;
  padding: 12px 20px;

  margin-bottom: 28px;
  &:hover {
    border-color: #868889 !important;
  }
`;
type MobileButtonProps = {
  phoneNumber: string;
};

export const MobileButtonContainer: React.FC<MobileButtonProps> = ({
  phoneNumber,
}) => {
  const t = useSanitizedTranslation();
  return (
    <MainButtonContainer>
      <TagButton
        size="medium"
        variant="outline"
        color="secondary"
        onClick={() => {
          window.open(`tel:${phoneNumber}`);
          trackEvent("Call_Prompt_Click", {
            buttonText: "Talk to an expert",
          });
        }}
      >
        <>
          {t("Talk to an expert")}
          <IconContainer>
            <Icon size="large" src="Phone" />
          </IconContainer>
        </>
      </TagButton>
    </MainButtonContainer>
  );
};
